module.exports = __webpack_public_path__ + "img/Launchpad.3a6e49f6.svg";